import type { RouteObject } from "react-router-dom";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import CategoryPage from "../pages/category/page";
import DetailPage from "../pages/detail/page";
import SearchPage from "../pages/search/page";
import SpecialsPage from "../pages/specials/page";
import AboutPage from "../pages/about/page";
import NotFound from "../pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/category/:type", element: <CategoryPage /> },
      { path: "/detail/:id", element: <DetailPage /> },
      { path: "/search", element: <SearchPage /> },
      { path: "/specials", element: <SpecialsPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;